import * as React from "react";
import { forwardRef } from "react";
const SvgReportArrowDown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1{fill:#0d5fbe;fill-rule:evenodd;}")), /* @__PURE__ */ React.createElement("polygon", { className: "cls-1", points: "0 12.48 19.95 38.72 40 12.48 26.34 12.48 26.34 1.28 13.56 1.28 13.56 12.48 0 12.48" }));
const ForwardRef = forwardRef(SvgReportArrowDown);
export { ForwardRef as ReactComponent };
